import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { type AppState } from '~/store/app.store';

export const mapSettingsDataLayerGroupsSelector = (state: AppState) => state.map.mapSettings.data.dataLayers.instances;
export const useMapSettingsDataLayerGroupsSelector = () => useSelector(mapSettingsDataLayerGroupsSelector);

export const mapSettingsActiveDataLayerGroupSelector = (state: AppState) => {
  const instances = mapSettingsDataLayerGroupsSelector(state);
  // for now we support only one active data layer at a time
  return instances.length > 0 ? instances[0] || null : null;
};
export const useMapSettingsActiveDataLayerGroupSelector = () => useSelector(mapSettingsActiveDataLayerGroupSelector);

export const mapSettingsBoundaryGroupsPerDataLayersSelector = (state: AppState) => state.map.mapSettings.data.dataLayers.boundaryGroup;
export const useMapSettingsBoundaryGroupsPerDataLayersSelector = () => useSelector(mapSettingsBoundaryGroupsPerDataLayersSelector);

export const mapSettingsDataLayersIndividualLayerSettingsSelector = (state: AppState) =>
  state.map.mapSettings.data.dataLayers.individualLayerSettings;
export const useMapSettingsDataLayersIndividualLayerSettingsSelector = () => useSelector(mapSettingsDataLayersIndividualLayerSettingsSelector);

export const mapSettingsDataLayersPrimaryBoundaryGroupIdSelector = (state: AppState) => {
  const activeDataLayer = mapSettingsActiveDataLayerGroupSelector(state);
  const boundaryGroupsPerDataLayers = mapSettingsBoundaryGroupsPerDataLayersSelector(state);

  if (activeDataLayer && boundaryGroupsPerDataLayers[activeDataLayer.id]) {
    return boundaryGroupsPerDataLayers[activeDataLayer.id];
  }

  return null;
};
